import React from 'react';
import { FormattedMessage } from 'react-intl';

import { IconRegularDiamond } from '@notino/react-styleguide-v20';

import { BenefitItem } from '@sharedComponents/Benefits';
import { ReactFCV } from '@types';
import { getNumberInNegative } from '@utils/math';

import { IDiscountWrapper } from './components';
import { DiscountBody } from './components/DiscountBody';
import { StyledDisabledMessage } from './components/styled';
import { messages } from './messages';

interface ILoyaltyDiscountItemProps extends IDiscountWrapper {
  isDualPriceLayout: boolean;
}

export const LoyaltyDiscountItem: ReactFCV<ILoyaltyDiscountItemProps> = ({
  percentValue,
  discountListName,
  discountType,
  priceValue,
  isDisabled,
  isPartiallyDisabled,
  isDualPriceLayout,
}) => (
  <BenefitItem
    icon={<IconRegularDiamond />}
    benefitDisabled={isDisabled}
    title={
      <DiscountBody
        discountListName={discountListName}
        discountType={discountType}
        isDisabled={isDisabled}
        percentValue={percentValue}
      />
    }
    value={getNumberInNegative(priceValue)}
    isDualPriceLayout={isDualPriceLayout}
    info={
      isDisabled || isPartiallyDisabled ? (
        <StyledDisabledMessage>
          <FormattedMessage {...messages.discountDisabled} />
        </StyledDisabledMessage>
      ) : null
    }
  />
);
